import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import api from '../../api/api';
import { authActions } from '../../store/auth';
import { errorHandler } from '../../utils/helper';
import './_navbar.scss';
import { Col, Row } from 'antd';
import { useCollapseNavbar } from '../../hooks/useCollapseNavbar';
import rightArrowIcon from '../../assets/icons/navbar/right-arrow.svg';
import { useEffect } from 'react';

interface Props {
  to?: string;
  children: string;
  icon: string | React.ReactNode;
  onClick?: any;
  group?: boolean;
}

const NavbarItem: React.FC<Props> = ({ to, children, icon, onClick, group }) => {
  const { collapsed, hoverExpanded } = useCollapseNavbar(),
    dispatch = useDispatch(),
    updateNotificationCount = () => {
      api.notification.getCount()
        .then((res) => {
          dispatch(
            authActions.setNotification({
              notification_count: res?.data?.notification_count,
            }));
        })
        .catch((err) => { errorHandler(err?.response) });
    }, buttonWithIcon = (
      <Row className={`navbar-item no-margin`} align="middle" gutter={8}>
        <Col className="navbar-icon">
          {typeof icon === 'string' ? <img src={icon} alt={children} /> : icon}
        </Col>
        {(!collapsed || hoverExpanded) && <Col className="navbar-item-text">{children}</Col>}
      </Row>
    );

    useEffect(() => {
      console.log('collapsed', collapsed);
    },[collapsed])


  if (to) {
    return (
      <NavLink
        to={to}
        className={(navData) => (navData.isActive ? 'nav-link active' : 'nav-link')}
        onClick={updateNotificationCount}>
        {buttonWithIcon}
      </NavLink>
    );
  } else {
    return (
      <Row className={'nav-link cursor-pointer'} style={{ width: '100%' }} onClick={onClick} align="middle" justify="space-between">
        <Col className='w-full'>
          {buttonWithIcon}
        </Col>
        {group && !collapsed && <Col className='collapse-icon' style={{
          float: 'right'
        }}>
          <img src={rightArrowIcon} className='navbar-right-arrow' alt="right-arrow" />
        </Col>}
      </Row>
    )
  };
};

export default NavbarItem;
